const AISocialIcon = (props) => {
  const { size = 24, color = "currentColor" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 9.77778C14 10.151 13.8595 10.509 13.6095 10.773C13.3594 11.0369 13.0203 11.1852 12.6667 11.1852H4.66667L2 14V2.74074C2 2.36748 2.14048 2.0095 2.39052 1.74556C2.64057 1.48162 2.97971 1.33334 3.33333 1.33334H12.6667C13.0203 1.33334 13.3594 1.48162 13.6095 1.74556C13.8595 2.0095 14 2.36748 14 2.74074V9.77778Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66699 3.33334L7.02966 5.271C6.99704 5.37017 6.94159 5.4603 6.86777 5.53411C6.79395 5.60793 6.70383 5.66339 6.60466 5.696L4.66699 6.33334L6.60466 6.97067C6.70383 7.00329 6.79395 7.05874 6.86777 7.13256C6.94159 7.20638 6.99704 7.2965 7.02966 7.39567L7.66699 9.33334L8.30433 7.39567C8.33694 7.2965 8.39239 7.20638 8.46621 7.13256C8.54003 7.05874 8.63016 7.00329 8.72933 6.97067L10.667 6.33334L8.72933 5.696C8.63016 5.66339 8.54003 5.60793 8.46621 5.53411C8.39239 5.4603 8.33694 5.37017 8.30433 5.271L7.66699 3.33334Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.33301 4V4.33333" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.667 8.66666V9" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 3.33334V3.66667" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default AISocialIcon;
